export const avvio = 
{
  "label": "Avvio",
  "children": [
    {
      "name": "FASE A EFRAG - Individuazione e selezione stakeholder e ambiti di intervento per tipologia (SCHEDE DI SUPPORTO)",
      "to": "/app/metodologia/fase-a",
      "exact": true,
      "active": true,
      "icon": "puzzle-piece"
    },
    {
      "name": "INPUT -> Selezione aziendale stakeholder (vedi SCHEDE 1 e 5)",
      "exact": true,
      "active": true,
      "to": "/app/questionario/selezione-stakeholder",
      "icon": "pencil-alt"
    },
    {
      "name": "INPUT -> Selezione aziendale ambiti principali (vedi SCHEDE 2 e 6)",
      "exact": true,
      "active": true,
      "to": "/app/questionario/selezione-ambiti",
      "icon": "pencil-alt"
    },
    {
      "name": "INPUT -> Analisi strategica dell'azienda per la sostenibilità (vedi SCHEDA 3)",
      "exact": true,
      "active": true,
      "to": "/app/questionario/analisi-strategica",
      "icon": "pencil-alt"
    },
    {
      "name": "FASE B EFRAG - Individuazione rischi e loro mitigazione (SCHEDE DI SUPPORTO)",
      "to": "/app/metodologia/fase-b",
      "exact": true,
      "active": true,
      "icon": "puzzle-piece"
    },
    {
      "name": "INPUT -> Identificazione periodi per la rilevazione (vedi SCHEDA 7)",
      "exact": true,
      "active": true,
      "to": "/app/questionario/selezione-anni",
      "icon": "pencil-alt"
    },
    {
      "name": "INPUT ->  Per l'input di identificazione rischi e azioni / kpi di mitigazione rischi si rimanda direttamente alla scheda del singolo ambito (vedi SCHEDE 8 e 9)",
      "exact": true,
      "active": true,
      "to": "/app/questionario/identificazione-rischi-e-mitigazioni",
      "icon": "pencil-alt"
    },
    // **** TOGLIERE LINK NELLA VOCE PRECEDENTE *** \\

    {
      "name": "FASE C EFRAG - Valutazione rischi e loro mitigazione (SCHEDE DI SUPPORTO)",
      "to": "/app/metodologia/fase-c",
      "exact": true,
      "active": true,
      "icon": "puzzle-piece"
    },
    {
      "name": "INPUT ->  Per l'input valutazione rilevanza rischi di impatto/finanziari e mitigazione rischi con azioni/opportunità si rimanda direttamente alla scheda del singolo ambito (vedi SCHEDE 10, 11 e 12)",
       "to": "/app/questionario/valutazione-rilevanza-rischi-e-mitigazioni",
      "exact": true,
      "active": true,
      "icon": "pencil-alt"
    }
    // **** TOGLIERE LINK NELLA VOCE PRECEDENTE *** \\

  ]
}
